import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-gray-500" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = ["textContent"]

import { toRefs } from 'vue';
import { NftMetadataAccountDataCreator } from '@/coders';
import { NftMetadataCreator } from '@/models';
import { getAccountRoute, shortenPublicKey, toPublicKeyAsString } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    creators: null
  },
  setup(__props: any) {

const props = __props as {
  creators: NftMetadataAccountDataCreator[] | NftMetadataCreator[],
}



const { creators } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_fingerprint = _resolveComponent("icon-fingerprint")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!

  return (_unref(creators)?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(creators), (creator) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _unref(toPublicKeyAsString)(creator.address),
              class: "flex items-center space-x-4"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  class: "font-mono hover:text-gray-900",
                  to: _unref(getAccountRoute)(creator.address)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(shortenPublicKey)(creator.address, 10)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("div", null, _toDisplayString(creator.share) + "%", 1),
              ((typeof creator.verified !== 'undefined'))
                ? (_openBlock(), _createBlock(_component_base_dropdown, {
                    key: 0,
                    "menu-class": "px-2 py-1",
                    placement: "bottom"
                  }, {
                    default: _withCtx(({ hoverListeners }) => [
                      _createVNode(_component_icon_fingerprint, _mergeProps(_toHandlers(hoverListeners), {
                        class: ["w-5 h-5", creator.verified ? 'text-indigo-500' : 'text-gray-400']
                      }), null, 16, ["class"])
                    ]),
                    menu: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "whitespace-nowrap text-sm",
                        textContent: _toDisplayString(creator.verified ? 'Verified' : 'Unverified')
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})